import React, { useState } from "react";
import axios from "axios";
import useAuth from "../../../../hooks/useAuth";
import { BASE_URL } from "../../../../utils/Element";
import Modal from "../../../../components/Modal/Modal";
import { NotificationManager } from "react-notifications";

const AddContagTagModal = ({ showModal, onClose, onCallApi }) => {
  const [config] = useAuth();
  const [error, setError] = useState();
  const [tagName, setTagName] = useState("");
  const [disable, setDisable] = useState(false);

  const handleClose = () => {
    onClose();
    setTagName("");
    setError();
    setDisable(false);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setDisable(true);
    axios
      .post(`${BASE_URL}/add-contact-tag`, { tag_name: tagName }, config)
      .then((res) => {
        onCallApi();
        handleClose();
        if (res?.data?.message) {
          NotificationManager.success(res?.data?.message);
        }
      })
      .catch((err) => {
        setError(err?.response?.data?.errors);
        if (err.response?.data?.message && err.response?.data?.message !== "Too Many Attempts.") {
          NotificationManager.error(err.response?.data?.message);
        }
      })
      .finally(() => {
        setDisable(false);
      });
  };

  return (
    <Modal title={"Add Tag"} desc={"This tag will be accessible for item owned by Tri-Oak Consulting Group"} show={showModal} onClose={handleClose}>
      <form className="mt-3" onSubmit={handleSubmit}>
        <div>
          <label className="dark-H head-4 mb-2 required:*:">
            Tag Name
            <span className="red-D">*</span>
          </label>
          <input
            className="body-N"
            name="tagName"
            type="text"
            placeholder="Enter Contact Tag Name Here....."
            value={tagName}
            onChange={(e) => {
              setError();
              const onlyAlphabets = e.target.value;
              setTagName(e.target.value);
            }}
          />
          {error?.tag_name && <span className="body-S red-D">{error?.tag_name}</span>}
        </div>

        <div className="mt-8">
          <button type="submit" disabled={disable || tagName === ""} className="save-button light-L head-5 green-bg-H">
            Add
          </button>
          <button type="button" onClick={handleClose} className="green-H ml-5">
            Cancel
          </button>
        </div>
      </form>
    </Modal>
  );
};

export default AddContagTagModal;
